export default __webpack_public_path__ + "static/latency-mobile3-cfd0c43ee9e23d649eeb35afcc2dd8b0.png";